exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header {\n  color: #ffffff;\n  height: 2.75rem;\n}\n.back-img {\n  width: 1.88rem;\n  height: 1.88rem;\n}\n.am-navbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 45px;\n  background: none;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true,"modifyVars":{"@brand-primary":"#A0B8FF"}}!./src/components/Header/index.less
// module id = 269
// module chunks = 150